import "core-js/modules/es6.array.sort";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-917a87695cc943acae31ac6086276c76/input/1603358965782/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import request from "../util/request";
var cgiUrl = '//vip.video.qq.com/fcgi-bin/comm_cgi?name=spp_PropertyNum&cmd=1&growth_value=1&otype=json';
var _normalizer = {
  GrowthValue: function GrowthValue(data) {
    return {
      id: 'growth',
      amount: data.num,
      text: '成长值',
      url: '//film.qq.com/vip/level.html',
      priority: 0
    };
  },
  MovieTicket: function MovieTicket(data) {
    return {
      id: 'ticket',
      amount: data.num,
      text: '观影券',
      url: '//v.qq.com/u/hlw/hlw_index.html',
      priority: 10
    };
  },
  VipVoucher: function VipVoucher(data) {
    return {
      id: 'voucher',
      amount: data.num,
      text: '优惠券',
      priority: 100
    };
  },
  GiveMovie: function GiveMovie(data) {
    return {
      id: 'present',
      amount: data.num,
      text: '赠片资格',
      url: '//v.qq.com/u/hlw/hlw_index.html?tab=3',
      priority: 1000
    };
  },
  SinglePay: function SinglePay(data) {
    return {
      id: 'order',
      amount: data.num,
      text: '购买记录',
      url: '//v.qq.com/u/hlw/hlw_index.html?tab=2',
      priority: 10000
    };
  }
};
export default function req(_x) {
  return _req.apply(this, arguments);
}

function _req() {
  _req = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(isVip) {
    var walletRes;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _reqWalletItems();

          case 2:
            walletRes = _context.sent;
            console.log(walletRes);
            return _context.abrupt("return", _normalizeWallet(walletRes).filter(function (item) {
              if (item.id === 'voucher') {
                return true;
              }

              if (isVip && ['ticket', 'score'].indexOf(item.id) > -1) {
                return true;
              }

              return item.amount > 0;
            }).sort(function (a, b) {
              return a.priority - b.priority;
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _req.apply(this, arguments);
}

function _reqWalletItems() {
  return _reqWalletItems2.apply(this, arguments);
}

function _reqWalletItems2() {
  _reqWalletItems2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return request(cgiUrl);

          case 2:
            res = _context2.sent;

            if (!(!res || !$.isPlainObject(res))) {
              _context2.next = 6;
              break;
            }

            console.warn('[services.wallet._reqWalletItems]invalid response format. ', res);
            throw new Error('无效的数据格式');

          case 6:
            if (!(res.result && res.result !== 0)) {
              _context2.next = 9;
              break;
            }

            console.warn('[services.wallet._reqWalletItems]', res.result.msg);
            throw new Error('无效的数据格式');

          case 9:
            return _context2.abrupt("return", res);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _reqWalletItems2.apply(this, arguments);
}

function _normalizeWallet(res) {
  var k;
  var v;
  var item;
  var items = [];

  for (k in res) {
    v = res[k];

    if (!v || v.errCode !== 0) {
      continue;
    }

    try {
      item = _normalizeWalletItem(k, v);
      items.push(item);
    } catch (e) {
      console.warn(e.message);
    }
  }

  return items;
}

function _normalizeWalletItem(walletType, data) {
  if (_normalizer[walletType]) {
    return _normalizer[walletType](data);
  }

  throw new Error('[services.wallet._normalizeWalletItem]unknown wallet type', walletType);
}